import { inject, Injectable } from '@angular/core';
import { selectTruckById } from '@app/store/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { getRouteParamFromLeafToRoot } from '@app/shared/utils/route-utils';

@Injectable()
export class HasUuidGuard  {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    const truckIdString = getRouteParamFromLeafToRoot(routeSnapshot, 'truckId');
    const truckId = Number.parseInt(truckIdString);

    return this.store.select(selectTruckById(truckId)).pipe(
      map((selectedTruck) => {
        if (truckIdString === 'new' || (selectedTruck && !selectedTruck.uuid)) {
          this.router.navigate(['/app', 'trucks', `${selectedTruck?.id || 'new'}`, 'general'])
            .catch(err => console.error('An error occurred during navigation:', err));
        }

        return selectedTruck;
      }),
      map(selectedTruck => !!selectedTruck?.uuid),
    );
  }
}
